import React, { Component, createRef, useMemo } from 'react';
import { submitForm, phoneRegX, emailRegX, allowFileTypes, allowFileTypesCareer } from './submitForm';
import IconCheckmarkImage from "../../../../icons/icon-checkmark.svg";
import Dropzone from 'react-dropzone';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import '../../../../sass/material.scss';
import { Link, navigate } from "gatsby";

export default class FormSectionCareer extends Component {
  constructor(props) {
    super(props);
    this.dropzoneRef = createRef();
    this.fnameRef = createRef();
    this.referrer = null;
    this.state = {
      fname: '',
      fnameValidation: '',
      lname: '',
      lnameValidation: '',
      phone: '',
      phoneValidation: '',
      email: '',
      emailValidation: '',
      experience: '',
      experienceValidation: '',
      position: this.props.jobType,
      positionValidation: 'success-field',
      message: '',
      messageValidation: '',
      resume: [],
      resumeValidation: '',
      shouldSubmit: false,
      submitButtonState: ''
    };
  }

  clearFields = () => {
    this.setState({
      fname: '',
      fnameValidation: '',
      lname: '',
      lnameValidation: '',
      phone: '',
      phoneValidation: '',
      email: '',
      emailValidation: '',
      experience: '',
      experienceValidation: '',
      position: this.props.jobType,
      positionValidation: '',
      message: '',
      messageValidation: '',
      resume: [],
      resumeValidation: '',
      shouldSubmit: false,
      submitButtonState: ''
    });
  };

  checkFields = () => {
    const { fnameValidation, lnameValidation, emailValidation, phoneValidation, positionValidation, resumeValidation, experienceValidation, messageValidation } = this.state;
    return new Promise((resolve, reject) => {
      if (fnameValidation === 'success-field' &&
        lnameValidation === 'success-field' &&
        emailValidation === 'success-field' &&
        phoneValidation === 'success-field' &&
        messageValidation === 'success-field' &&
        positionValidation === 'success-field' &&
        resumeValidation === 'success-field' &&
        experienceValidation === 'success-field') {
        this.setState({
          shouldSubmit: true
        });
      }
      resolve({
        ...(!fnameValidation) && { fnameValidation: 'error-field', shouldSubmit: false },
        ...(!lnameValidation) && { lnameValidation: 'error-field', shouldSubmit: false },
        ...(!emailValidation) && { emailValidation: 'error-field', shouldSubmit: false },
        ...(!phoneValidation) && { phoneValidation: 'error-field', shouldSubmit: false },
        ...(!messageValidation) && { messageValidation: 'error-field', shouldSubmit: false },
        ...(!positionValidation) && { positionValidation: 'error-field', shouldSubmit: false },
        ...(!experienceValidation) && { experienceValidation: 'error-field', shouldSubmit: false },
        ...(!resumeValidation) && { resumeValidation: 'error-field', shouldSubmit: false },
      });
    });
  };

  componentDidUpdate() {
    this.props.isVisible && this.fnameRef.current.focus();
  }

  /* componentDidMount() {
    this.referrer = document.referrer
  } */

  onSubmit = (event) => {

    const submitData = async () => {
      if (this.state.shouldSubmit) {
        this.setState({
          submitButtonState: "inProgress"
        });
        const formData = new FormData();
        formData.append("form_id", "6");
        formData.append("input_1", this.state.fname);
        formData.append("input_2", this.state.lname);
        formData.append("input_3", this.state.phone);
        formData.append("input_4", this.state.email);
        formData.append("input_5", this.state.experience);
        formData.append("input_6", this.state.position);
        formData.append("input_7", this.state.message);
        formData.append("input_8", this.state.resume[0]);
        formData.append("input_9", localStorage.getItem("referrer"));
        const requestData = {
          method: 'post',
          url: 'https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/forms/6/submissions',
          data: formData
        };
        try {
          const response = await submitForm(requestData);
          if ( response.status === 201 ) {
            setTimeout(() => {
              this.setState({
                submitButtonState: "finished"
              });
            }, 600);
          }
          setTimeout(() => {
            this.clearFields();
            navigate("/thank-you/");
          }, 500);
        } catch (error) {
          console.log(error);
        }
      }
    };

    if (this.state.submitButtonState === '') {
      this.checkFields()
        .then(
          (res) => this.setState(res, submitData)
        );
      event.preventDefault();
    }
  };

  handleChange = (e) => {
    const name = e.target ? e.target.name : 'phone';
    const value = e.target ? e.target.value : e;
    const newState = {};
    switch (name) {
      case 'fname':
        if (!value)
          this.setState({
            fnameValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            fnameValidation: 'success-field',
          });
        break;

      case 'lname':
        if (!value)
          this.setState({
            lnameValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            lnameValidation: 'success-field',
          });
        break;

      case 'phone':
        if (!value)
          this.setState({
            phoneValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            phoneValidation: 'success-field',
          });
        break;

      case 'email':
        if (!emailRegX.test(value))
          this.setState({
            emailValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            emailValidation: 'success-field',
          });
        break;

      case 'experience':
        if (!value)
          this.setState({
            experienceValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            experienceValidation: 'success-field',
          });
        break;

      case 'position':
        if (!value)
          this.setState({
            positionValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            positionValidation: 'success-field',
          });
        break;

      case 'message':
        if (value.length < 5)
          this.setState({
            messageValidation: 'error-field',
            shouldSubmit: false,
          });
        else
          this.setState({
            messageValidation: 'success-field',
          });
        break;

      default:
        break;
    }
    if (name !== "resume") {
      newState[name] = value;
    }
    this.setState(newState);
  };

  onDrop = (files) => {
    if (files.length > 0)
      this.setState({
        resume: files,
        resumeValidation: 'success-field'
      });
  };

  openDialog = () => {
    // Note that the ref is set async,
    // so it might be null at some point 
    if (this.dropzoneRef.current) {
      this.dropzoneRef.current.open();
    }
  };

  render() {
    const { fnameValidation, lnameValidation, emailValidation, phoneValidation,
      positionValidation, resumeValidation, experienceValidation, messageValidation, submitButtonState } = this.state;
    return (
      <div className="form-section" id="form-section">
        <div className="container">
          <h3 className="form-title">Apply for this job</h3>
          <form name="contact" onSubmit={this.onSubmit} className="fomt-style-fancy">
            <div className="form-row has-three-column">
              <div className="form-column">
                <input ref={this.fnameRef} placeholder="First Name*" type="text" className={`form-input ${fnameValidation}`} id="fname" name="fname" autoComplete="off" onChange={this.handleChange} value={this.state.fname} />
              </div>
              <div className="form-column">
                <input placeholder="Last Name*" type="text" className={`form-input LoNotSensitive ${lnameValidation}`} id="lname" name="lname" autoComplete="off" onChange={this.handleChange} value={this.state.lname} />
              </div>
              <div className="form-column">
                <PhoneInput
                  country='in'
                  preferredCountries={['us', 'in', 'ca', 'de', 'au', 'gb']}
                  preserveOrder={['preferredCountries']}
                  enableSearch
                  placeholder="Phone*"
                  inputClass={this.state.phoneValidation}
                  id="phone"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.handleChange} />
              </div>
            </div>
            <div className="form-row has-three-column">
              <div className="form-column">
                <input placeholder="Email*" type="email" name="email" className={`form-input LoNotSensitive ${emailValidation}`} id="email" autoComplete="off" onChange={this.handleChange} value={this.state.email} />
              </div>
              <div className="form-column">
                <input placeholder="Total Experience in Years*" type="text" name="experience" className={`form-input LoNotSensitive ${experienceValidation}`} id="experience" autoComplete="off" onChange={this.handleChange} value={this.state.experience} />
              </div>
              <div className="form-column">
                <input placeholder="Position" disabled type="text" name="position" className="form-input LoNotSensitive" id="position" autoComplete="off" onChange={this.handleChange} value={this.state.position} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-column">
                <textarea placeholder="I want to join Rapidops because*" rows="4" name="message" className={`form-input textarea-small ${messageValidation}`} id="message" cols="20" autoComplete="off" onChange={this.handleChange} value={this.state.message} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-column">
                <Dropzone
                  ref={this.dropzoneRef}
                  noClick
                  noKeyboard
                  onDrop={this.onDrop}
                  accept={allowFileTypesCareer}
                  minSize={0}
                  maxSize={11010048}
                >
                  {({ getRootProps, getInputProps, acceptedFiles, isDragActive, isDragReject, fileRejections }) => {
                    const isFileTooLarge = fileRejections && fileRejections.length > 0 && fileRejections[0].file.size > 11010048;
                    return (
                      <div>
                        <div {...getRootProps({ className: 'dropzone ' + resumeValidation })}>
                          <input {...getInputProps()} className="LoNotSensitive"/>
                          {(this.state.resume.length >= 0 && resumeValidation !== 'error-field') && <p className="dragDrop">Drag & Drop your file here <br />PDF or Word files with less than 10MB in size are supported.</p>}
                          {this.state.resume.length === 0 && <p className="no-select-file">Resume format ( .pdf, .doc )</p>}
                          {this.state.resume.length > 0 && <p className="fileName">{this.state.resume[0].name}</p>}
                          {isDragActive && !isDragReject && !isFileTooLarge && <p className="dropItFile">Drop it like it's hot!</p>}
                          {isDragReject && <p>File type not accepted, sorry!</p>}
                          {isFileTooLarge && (
                            <p>
                              File is too large.
                            </p>
                          )}
                          {resumeValidation === 'error-field' && (
                            <p>
                              Please upload your resume<br />PDF, Word, Excel, PNG, JPEG, and TXT files with less than 25MB in size are supported.
                            </p>
                          )}
                          <button
                            type="button"
                            onClick={this.openDialog}>
                            Choose File
                          </button>
                        </div>
                      </div>
                    );
                  }}
                </Dropzone>
              </div>
            </div>

            <div className="form-action">
              <button type="submit" className={`button right-arrow ${submitButtonState}`}>
                <span className="submit">Get Started</span>
                <span className="loading">Get Started</span>
                <span className="check"><IconCheckmarkImage /></span>
              </button>
              <p>By clicking the button, you consent on the processing of personal data.</p>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
